export default {
  gop: {
    abbr: 'R',
    label: 'Republican',
  },
  dem: {
    abbr: 'D',
    label: 'Democrat',
  },
  lib: {
    abbr: 'L',
    label: 'Libertarian',
  },
  grn: {
    abbr: 'G',
    label: 'Green',
  },
  npp: {
    abbr: 'NP',
    label: 'No party',
  },
  np: {
    abbr: 'NP',
    label: 'No party',
  },
  aip: {
    abbr: 'AI',
    label: 'American Independent',
  },
  pfp: {
    abbr: 'PF',
    label: 'Peace and Freedom',
  },
  prp: {
    abbr: '',
    label: '',
  },
};